import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/docker': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M349.9 236.3h-66.1v-59.4h66.1v59.4zM349.9 32v60.7h-66.1v-60.7h66.1zM428.1 176.8v59.4h-66.1v-59.4h66.1zM271.8 104.7v60.1h-66.1v-60.1h66.1zM349.9 104.7v60.1h-66.1v-60.1h66.1zM626.7 204.7l13.3 8.9c-1.9 3.9-7 14.6-8.5 17.1-23.7 45.3-69.9 45.6-91.3 45.2-54.5 131.7-171 204.2-328.4 204.2-72.7 0-128.3-22.3-165.4-66.2-38.2-45.3-52.7-111.3-44-162.1h434.7c22.6 0.4 39.7-6 48.4-10.7-19.7-30.2-14.7-76 3.7-103.8l9.3-14 14 9.3c24.4 18.8 37.8 39.7 41.1 63.7 25.5-4.8 58.7-1.3 73.1 8.4zM115.6 176.8h0.1v59.4h-66.1v-59.4h66zM193.7 176.8v59.4h-66.1v-59.4h66.1zM271.8 176.8v59.4h-66.1v-59.4h66.1zM193.7 104.7v60.1h-66.1v-60.1h66.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/docker.js
// module id = 796
// module chunks = 0